import { getApi } from '../api/storeFront';
import { parseCartItems } from '../utils';
const getCart = async ({ count, cursor }, logger) => {
    const urlParams = new URLSearchParams();
    urlParams.append('count', count.toString());
    urlParams.append('cursor', cursor.toString());
    const response = await getApi(`/{userId}/cart?${urlParams.toString()}`, logger);
    const lineItems = response?.data?.lineItems;
    const isOrderCompleted = response?.data?.status && response?.data?.status === 'COMPLETED';
    // API does not provide media so for now adding dummy media URL.
    const media = [
        {
            url: 'https://cdn.shopify.com/s/files/1/0742/9911/3793/files/Photobook2.jpg?v=1689140166',
        },
        {
            url: 'https://cdn.shopify.com/s/files/1/0742/9911/3793/files/Phonecase1.jpg?v=1688102972',
        },
        {
            url: 'https://cdn.shopify.com/s/files/1/0742/9911/3793/files/Photobook2_55271e2b-5ecf-4581-9419-575b99a75dcb.jpg?v=1688100069',
        },
    ];
    let parsedData = [];
    if (isOrderCompleted) {
        return {
            data: parsedData,
            cartId: '',
            subtotalPrice: '',
            totalPrice: '',
            invoiceUrl: '',
            status: '',
            size: undefined,
            paginate() {
                return !!response.hasNextPage && getCart({ count, cursor: response?.cursor }, logger);
            },
        };
    }
    if (response?.size && response.size > 0) {
        parsedData = [...parseCartItems(lineItems)];
    }
    response?.data?.lineItems.map((_, index) => {
        parsedData[index].media = media;
    });
    return {
        data: parsedData,
        cartId: response?.data?.cartId,
        subtotalPrice: response?.data?.subtotalPrice,
        totalPrice: response?.data?.totalPrice,
        invoiceUrl: response?.data?.invoiceUrl,
        status: response?.data?.status,
        size: response?.size,
        paginate() {
            return !!response.hasNextPage && getCart({ count, cursor: response?.cursor }, logger);
        },
    };
};
export default getCart;
